// extracted by mini-css-extract-plugin
export var content = "personal-project-module--content--6d98e";
export var description = "personal-project-module--description--10780";
export var featured = "personal-project-module--featured--007b4";
export var icon = "personal-project-module--icon--1fc4a";
export var image = "personal-project-module--image--102ab";
export var personalProject = "personal-project-module--personal-project--55150";
export var tagsUl = "personal-project-module--tags-ul--5e9e2";
export var title = "personal-project-module--title--31b6e";